var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"500px"}},[_c('example-description',{attrs:{"subject":"InfinitePaginationTable 은 Data Table 에 무한 페이징 기능을 자동으로 제공합니다.","content":"서버 요청이나 같은 로직에 종속되지 않고 아이템 목록을 반환하는 메서드를 통해 자유롭게 사용할 수 있습니다."}}),_c('infinite-pagination-table',{attrs:{"next":_vm.next,"headers":_vm.headers}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }